import {useEffect, useState} from "react";


const GenericCurrencyCard = (props) => {
    const title = props.title
    const value = props.value
    const setValue = props.setValue

    const formatNumber = (_string) => {
        return _string && _string.replace(/\D/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return(
        <>
            <div className="generic-string-card-container" >
                <div className="generic-string-card-header-container">
                    <div className={"generic-string-card-header"}>
                        {title}
                    </div>
                </div>
                <div className="generic-string-currency-container">
                    <input type="text" pattern="[0-9]*" value={value && "£" + formatNumber(value)}
                           placeholder={""} onChange={(ev) =>
                        setValue(ev.target.value.replace("£","").replace(",",""))
                    }/>
                </div>
            </div>
        </>
    )
}

export default GenericCurrencyCard